// @flow
export const TAB_KEY = 'tab';
export const TAB_ACTIONS = 'actions';
export const TAB_DISCOVER = 'discover';



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/constants.js